import { useUserContext } from 'src/lib/contexts/UserContext';
import styled from "src/lib/styles/css";
//#region [Styles]

//#endregion

//#region [Props]
type UserNameProps = {
	userName?: string;
	className?: string;
};
//#endregion

//#region [Component]
export default function UserName({ userName, className }: UserNameProps) {
	const userContext = useUserContext();
	let _userName = userName || userContext.userProfile?.userName;
	if (!_userName) return null;

	if( _userName === "GDPRDELETED") {
		_userName = '👻';
	}

	return (
		<div className={className} title={_userName}>
			{_userName}
		</div>
	);
}
//#endregion